import { render, staticRenderFns } from "./BuyerCampaignDetails.vue?vue&type=template&id=3b38434c&scoped=true"
import script from "./BuyerCampaignDetails.vue?vue&type=script&lang=js"
export * from "./BuyerCampaignDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38434c",
  null
  
)

export default component.exports